import { useEffect, useState } from 'react';

import { AlertDialog, Button } from '@backyard-ui/core';

interface RecontextAlertDialogProps {
  status: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function RecontextAlertDialog(
  props: Readonly<RecontextAlertDialogProps>
) {
  const { status, onCancel, onConfirm } = props;

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (status === 'invalid') {
      setIsOpen(true);
    }
  }, [status]);

  return (
    <AlertDialog.Root isOpen={isOpen} onOpenChange={setIsOpen} isCentered>
      <AlertDialog.Content>
        <AlertDialog.Title>Deseja atualizar sua região?</AlertDialog.Title>
        <AlertDialog.Description>
          O CEP que você inseriu para a entrega dos produtos é de uma região
          diferente, então,<strong> precisaremos atualizar nosso site</strong>{' '}
          para se adequar ao novo local. É possível que a{' '}
          <strong>
            disponibilidade dos produtos, frete e prazos de entrega sejam
            afetados.
          </strong>
        </AlertDialog.Description>
        <AlertDialog.Footer>
          <AlertDialog.Cancel asChild>
            <Button appearance="critical" variant="ghost" onClick={onCancel}>
              Não, cancelar
            </Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action>
            <Button onClick={onConfirm}>Sim, atualizar</Button>
          </AlertDialog.Action>
        </AlertDialog.Footer>
      </AlertDialog.Content>
    </AlertDialog.Root>
  );
}
